import Axios from '@/Axios'

class AuthService {
    async login(data) {
        return await Axios.post('wms.wms.api.auth.login', data)
    }

    async logout() {
        return await Axios.post('wms.wms.api.auth.logout')
    }

    async getSession() {
        return await Axios.get('wms.wms.api.auth.get_current_user')
    }

    async forgotPassword(data) {
        return await Axios.post('wms.wms.api.auth.forgot_password', data)
    }

    async updatePassword(data) {
        return await Axios.post('wms.wms.api.auth.update_password', data)
    }

    // async login(data) {
    //     return await Axios.post('invoice.invoice.api.auth.login', data)
    // }

    // async logout() {
    //     return await Axios.post('invoice.invoice.api.auth.logout')
    // }

    // async getSession() {
    //     return await Axios.get('invoice.invoice.api.auth.get_current_user')
    // }

    // async forgotPassword(data) {
    //     return await Axios.post('invoice.invoice.api.auth.forgot_password', data)
    // }

    // async updatePassword(data) {
    //     return await Axios.post('invoice.invoice.api.auth.update_password', data)
    // }
}

export default new AuthService()
